import { useState } from 'react';
import { Badge, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Copy, Check } from 'lucide-react';

interface CopyableIdProps {
  id: string;
  className?: string;
}

export const CopyableId = ({ id, className = '' }: CopyableIdProps) => {
  const [copied, setCopied] = useState(false);
  const shortId = id.substring(0, 8);

  const handleCopy = async (e: React.MouseEvent) => {
    e.stopPropagation();
    await navigator.clipboard.writeText(id);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <OverlayTrigger placement="top" overlay={<Tooltip>{copied ? 'Copied!' : `Click to copy: ${id}`}</Tooltip>}>
      <Badge
        bg="light"
        text="dark"
        className={`d-inline-flex align-items-center ${className}`}
        style={{ cursor: 'pointer', fontFamily: 'monospace', fontSize: '0.7rem' }}
        onClick={handleCopy}
      >
        {shortId}...
        {copied ? <Check size={10} className="ms-1 text-success" /> : <Copy size={10} className="ms-1" />}
      </Badge>
    </OverlayTrigger>
  );
};
